
import {onSSR} from '@vue-storefront/core';
import {useContent} from '@vue-storefront/storyblok';
import {useContext, useRoute} from '@nuxtjs/composition-api';
import {useJobs} from '~/integrations/softgarden/src/composables/useJobs';
import {applyMetaFromContent} from '~/helpers/storyblok/storyblok';
import jobPosting from '~/helpers/googleSchema/jobPosting';
import isApprenticeship from '@/helpers/jobs/isApprenticeship';

export default {
  layout: 'default',
  props: {
    id: {
      type: String,
      default: null,
    },
  },
  setup() {
    const {
      jobs: job,
      searchJobById,
    } = useJobs();

    const {
      search: sbSearch,
      content,
    } = useContent();

    const {error} = useContext();

    const params = useRoute().value.params;


    onSSR(async () => {
      // Get job data from softgarden
      await searchJobById(params.jobId);

      if (!job.value || Object.keys(job.value).length === 0 || params.jobName !== job.value.urlName) {
        error({ statusCode: 404 });
        return;
      }

      if (isApprenticeship(job.value)) {
        await sbSearch({url: `ausbildung/${job.value.jobDbId}`, cache: false});
        if (!content.value || content.value.length <= 0) {
          await sbSearch({url: 'apprenticeship-details', cache: false});
        }
      } else {
        if (!content.value && content.value.length <= 0) {
          await sbSearch({url: `jobs/${job.value.jobDbId}`, cache: false});
        } else {
          await sbSearch({url: 'job-details', cache: false});
        }
      }

      if (typeof content.value !== 'object' || Array.isArray(content.value)) {
        error({ statusCode: 404 });
        return;
      }

    });

    return {
      content,
      job,
    };
  },
  head() {
    let meta = {
      title: null,
      meta: [],
      link: [],
    };

    // Apply meta info from storyblok page
    applyMetaFromContent(meta, this.content);

    if (this.job && this.job.externalPostingName) {
      meta.title = this.job.externalPostingName;
    }

    return {
      ...meta,
      script: [
        (this.job) ? {
          hid: 'googleTag',
          type: 'application/ld+json',
          innerHTML: jobPosting(this.job),
        } : {},
      ],
      __dangerouslyDisableSanitizersByTagID: {
        googleTag: ['innerHTML'],
      },
    };
  },
};
